import React, { useCallback } from "react";
import FileBrowser from "./FileBrowser";
import AwsService from "../../../service/awsService";
import { useParams } from "react-router-dom";

export default function S3FileBrowser(props) {
  const { Workspace_id } = useParams();

  let { url, path, hasUploadPermission = false, multipleFileSelection } = props;

  let pref = "";
  let bucketName = "";
  let fileName = multipleFileSelection ? [] : false;
  let bucketNameArray = [];

  //Setting default values based on url props
  bucketNameArray = url.replace("s3://", "").split("/");

  bucketName = bucketNameArray[0];
  bucketNameArray.shift();

  //Checking if path has file selected or folder
  const defaultPrefix = bucketNameArray.length ? bucketNameArray.join("/") : "";
  pref = defaultPrefix;

  if (bucketNameArray.length && pref && !pref.endsWith("/")) pref += "/";

  if (path) {
    //Adding or removing extra '/' and making complete prefix
    if (path.startsWith("/")) path = path.substring(1);

    if (multipleFileSelection) {
      const tempPathArr = [];

      path.split(",/").forEach((path, key) => {
        if (path.startsWith("/")) path = path.substring(1);

        const tPathArray = path.split("/");

        fileName.push(tPathArray.pop());

        path = path.replace(fileName[key], "");
        if (path === "/") path = "";

        tempPathArr.push(path);
      });

      // Check is files are selected from more than one folders then Browser will open with default container
      const uniquepathArr = [...new Set(tempPathArr)];

      if (uniquepathArr.length > 1) pref = defaultPrefix;
      else pref = pref + uniquepathArr[0];
    } else {
      const tPathArray = path.split("/");
      fileName = tPathArray.pop();
      let tpath = path;

      if (tpath[tpath.length - 1] !== "/") {
        tpath = tpath.replace(fileName, "");
      } else if (props.folderSelection) {
        if (tPathArray.length) fileName = tPathArray.pop();

        tpath = tpath.replace(fileName + "/", "");
      }
      if (tpath === "/") tpath = "";

      if (tpath) {
        if (pref) {
          pref = pref + tpath;
        } else {
          pref = tpath;
        }
      }
    }

    if (path.endsWith("/")) path = path.substring(0, path.length - 1);
  }

  //Getting file and folder data
  const getData = useCallback(async ({ bucketName, prefix, Stage_id, stage, ...params }) => {
    const aws = new AwsService();
    return await aws.getData({ s3bucketName: bucketName, prefix, Stage_id, ...params });
  }, []);

  //Download click
  const downloadClick = async ({ id, bucketName, fileName, Stage_id }) => {
    const aws = new AwsService();
    const response = await aws.getDownloadUrl(Workspace_id, {
      s3bucketName: bucketName,
      name: id,
      fileName,
      Stage_id,
    });

    if (response.success) window.location.href = response.data;
  };

  //Download button click
  const multipleDownload = async ({ bucketName, name, files, Stage_id }) => {
    let count = 0;

    const aws = new AwsService();
    const response = await aws.getDownloadUrl(
      Workspace_id,
      {
        s3bucketName: bucketName,
        name,
        Stage_id,
      },
      { files: files.join(",") }
    );

    if (response.success)
      response.data.forEach((url) => {
        const hiddenIFrameID = "hiddenDownloader" + count++;
        const iframe = document.createElement("iframe");
        iframe.id = hiddenIFrameID;
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        iframe.src = url;
      });
  };

  //Delete click
  const deleteClick = async ({ id, bucketName, Stage_id }) => {
    const aws = new AwsService();
    return await aws.delete({
      s3bucketName: bucketName,
      name: id,
      Stage_id,
    });
  };

  //Delete Button click (Multiple files)
  const multipleDelete = async ({ bucketName, name, Stage_id, files }) => {
    const aws = new AwsService();
    return await aws.delete({
      s3bucketName: bucketName,
      name,
      Stage_id,
      files,
    });
  };

  //Create Folder
  const manageObjectClick = async ({ bucketName, name, Stage_id, oldKey, objType }) => {
    const aws = new AwsService();
    return await aws.manageObject({
      s3bucketName: bucketName,
      name,
      Stage_id,
      oldKey,
      objType,
    });
  };

  return (
    <FileBrowser
      defaultPrefix={defaultPrefix && !defaultPrefix.endsWith("/") ? defaultPrefix + "/" : defaultPrefix}
      getData={getData}
      createFolderClick={manageObjectClick}
      deleteClick={deleteClick}
      multipleDownload={multipleDownload}
      multipleDelete={multipleDelete}
      downloadClick={downloadClick}
      pref={pref && !pref.endsWith("/") ? pref + "/" : pref}
      bucketName={bucketName}
      fileName={path}
      bucketNameArray={bucketNameArray}
      {...props}
      title="AWS S3 Explorer"
      type="s3"
      hasUploadPermission={hasUploadPermission}
    />
  );
}
